import { X } from "lucide-react";

const faqs = [
  {
    question: "I'm ready to book, what now?",
    answer: "Contact me through my contact form or reach out to me on my Facebook or Instagram page. Once your deposit is sent for your session, we will then discuss a date, locations, and I will send you a style guide."
  },
  {
    question: "Do you offer prints?",
    answer: "I do! Once your photo gallery is finished and sent over, there is an option to purchase prints straight from your online gallery. They will be professionally printed from a photo lab and delivered to your home in less than five days. I highly recommend ordering prints from me because the quality can't be beat."
  },
  {
    question: "Do you travel?",
    answer: "Yes, I do travel! I'm based out of the Breaux Bridge/Lafayette area but would love to travel to other areas. Please note that there is a separate travel fee."
  },
  {
    question: "How long will it take to receive my images?",
    answer: "My turnaround time is around 14 days for regular shoots and 8-12 weeks for weddings."
  },
  {
    question: "Can I purchase more digital images than what my package comes with?",
    answer: "Yes, to purchase additional photos it will be $10 per photo or $75 to upgrade to the full album."
  },
  {
    question: "What should we wear?",
    answer: "When you book with me, I will send a style guide that will help with picking out colors and outfits."
  },
];

const FAQPopup = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div 
      className="fixed inset-0 z-[100] flex items-center justify-center p-4"
      data-testid="faq-popup-overlay"
    >
      {/* Backdrop */}
      <div 
        className="absolute inset-0 bg-[#2C2A28]/60 backdrop-blur-sm"
        onClick={onClose}
      />
      
      {/* Modal */}
      <div 
        className="relative bg-[#FDFBF9] w-full max-w-2xl max-h-[80vh] overflow-hidden animate-fade-in-up"
        data-testid="faq-popup"
      >
        {/* Header */}
        <div className="sticky top-0 bg-[#FDFBF9] border-b border-[#E8E4DD] px-6 py-4 flex items-center justify-between">
          <div>
            <p className="overline text-[#C8A99C] text-xs">Got Questions?</p>
            <h2 className="font-heading text-2xl text-[#2C2A28]">FAQ</h2>
          </div>
          <button
            onClick={onClose}
            className="w-10 h-10 flex items-center justify-center text-[#5C5A56] hover:text-[#2C2A28] hover:bg-[#F5F2EB] transition-colors"
            data-testid="faq-close-button"
          >
            <X size={24} />
          </button>
        </div>

        {/* FAQ Content */}
        <div className="px-6 py-6 overflow-y-auto max-h-[calc(80vh-80px)]">
          <div className="space-y-6">
            {faqs.map((faq, index) => (
              <div 
                key={index} 
                className="pb-6 border-b border-[#E8E4DD] last:border-b-0 last:pb-0"
                data-testid={`faq-item-${index}`}
              >
                <h3 className="font-heading text-lg text-[#2C2A28] mb-2">
                  {faq.question}
                </h3>
                <p className="font-body text-sm text-[#5C5A56] leading-relaxed">
                  {faq.answer}
                </p>
              </div>
            ))}
          </div>

          {/* CTA */}
          <div className="mt-8 pt-6 border-t border-[#E8E4DD] text-center">
            <p className="font-body text-sm text-[#5C5A56] mb-4">
              Still have questions? I'd love to hear from you!
            </p>
            <a
              href="#contact"
              onClick={onClose}
              className="inline-block px-6 py-3 bg-[#2C2A28] text-[#FDFBF9] font-body text-sm tracking-wide hover:bg-[#5C5A56] transition-colors"
              data-testid="faq-contact-button"
            >
              Contact Me
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FAQPopup;
